import { render, staticRenderFns } from "./DocumentInformationSection.vue?vue&type=template&id=67fa0a37&"
import script from "./DocumentInformationSection.vue?vue&type=script&lang=js&"
export * from "./DocumentInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports